module.exports = __webpack_public_path__ + "static/media/appleEng.2928664f.svg";